





























import { Component, Prop } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ConsultoresService } from "@/services/consultores.service";

@Component({
  components: {
    Modal,
  },
})
export default class EditarObservacao extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  observacao: string | null = "";

  get tituloManter(): string {
    return "Editar Observação";
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async abrirModalObservacao(observacao: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.observacao = observacao;
    return p;
  }

  async salvarObservacao() {
    const modal = this.$refs.modal as Modal;

    this.startLoader();
    await ConsultoresService.EditarObservacao(
      this.idConsultor,
      this.observacao,
    ).finally(this.stopLoader);
    return modal.close(true);
  }

  limpar(){
    this.observacao = "";
  }
}
